// src/App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Welcome from "./components/Welcome/Welcome";
import DataFetcher from "./components/DataFetcher/DataFetcher";
import URLListInputForm from "./components/URLInputForm/URLInputForm";
import ScraperResult from "./components/ScraperResults/ScraperResults";
import HomeButton from "./components/HomeButton/HomeButton";

function App() {
  return (
    <Router>
      <div className="flex flex-col items-center justify-center min-h-screen p-8 bg-gradient-to-br from-blue-300 via-purple-300 to-lavender-400 bg-[length:400%_400%] animate-gradient-move">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Welcome />
              </>
            }
          />
          <Route path="/url-list" element={<URLListInputForm />} />
          <Route path="/results" element={<ScraperResult />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
